<template>
  <div id="app">
    <VNavbar
      title="系列藏品合集"
      background-image="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPgo="
      :show-border="false"
      :show-back="true"
      color="#000"
      :background-color="['transparent', '#fff']"
      @back="back"
    >
    </VNavbar>
    <ListView ref="loader" type="jump" func="fetchNftList" :query="query">
      <template #header="{ source }">
        <div class="panel">
          <div class="bg"></div>
          <div class="text">
            <div class="left">
              <p>{{ source.extra | itemName }}</p>
              <img
                width="16"
                height="16"
                src="./assets/help.svg"
                alt="help"
                @click="help"
              />
            </div>
            <NftFilter
              @changeActive="changeActive"
              :active_id="active_id"
              :isMaster="isMaster"
              :omitAll="omitAll"
            />
          </div>
        </div>
      </template>
      <template #default="{ list, extra }">
        <div class="nft-container">
          <NftItem
            v-for="item in list"
            :key="item.id"
            :item="item"
            :img-info="extra.img_info"
            :active_id="active_id"
          />
        </div>
      </template>
      <template #first-loading #loading>
        <div class="list-loading">
          <img
            src="//s1.hdslb.com/bfs/static/jinkela/long/images/loading-2233.png"
            alt="loading"
          />
          <p class="list-tip">正在玩命加载数据...</p>
        </div>
      </template>
      <template #first-error #error>
        <div class="list-error">
          <img
            src="//s1.hdslb.com/bfs/static/jinkela/long/images/error.png"
            alt="error"
          />
          <p class="list-tip">加载错误~</p>
          <div @click="retryList" class="list-error-btn">再试一次</div>
        </div>
      </template>
      <template #nothing>
        <div v-if="showPrivate" class="list-private">
          <img
            src="//s1.hdslb.com/bfs/static/jinkela/long/images/empty.png"
            alt="nothing"
          />
          <p class="list-tip">TA隐藏了藏品～</p>
        </div>
        <div v-else class="list-nothing">
          <img
            src="//s1.hdslb.com/bfs/static/jinkela/long/images/empty.png"
            alt="nothing"
          />
          <p class="list-tip">还没有藏品～</p>
        </div>
      </template>
      <template #footer="{ source }">
        <div class="nft-pagination-wrap" v-if="source.total > pageSize">
          <NftPagination
            :current-page="query.page"
            :page-total="source.total"
            :page-size="pageSize"
            :pager-count="5"
            :disabled="source.loading"
            @change="handlePaginationClick"
          >
          </NftPagination>
        </div>
      </template>
    </ListView>
  </div>
</template>

<script>
import { initEnv, biliBridge } from "@bilibili/js-bridge";
import { VNavbar } from "@bilibili/sakura";
import NftItem from "./components/NftItem.vue";
import NftFilter from "./components/NftFilter.vue";
import NftPagination from "./components/NftPagination.vue";
import { getUserInfo } from "./store/api";
import { reportEventJsb, ReportEventType } from "@/utils/report";

export default {
  name: "App",
  components: {
    VNavbar,
    NftItem,
    NftPagination,
    NftFilter,
  },
  filters: {
    itemName: (() => {
      let cache = "";
      return (extra) => {
        if (extra) {
          cache = extra.item_name;
        }
        return cache;
      };
    })(),
  },
  methods: {
    back() {
      biliBridge.callNative({
        method: "global.closeBrowser",
        callback: function () {},
      });
    },
    help() {
      this.$alert({
        message: "仅展示持有者同意公开的部分",
        buttons: ["知道了"],
        maskClose: true,
      });
    },
    resetPage(page) {
      const { query } = this.$route;
      this.$router.replace(
        { query: { ...query, page } },
        () => {},
        () => {}
      );
    },
    handlePaginationClick(page, type = "jump") {
      this.resetPage(page);
      this.$refs.loader[type](page);
    },
    changeActive(index) {
      this.active_id = index;
    },
    retryList() {
      this.$refs["loader"].retry();
    },
  },
  data() {
    return {
      pageSize: 10,
      selected5: [1, 5],
      isMaster: false,
      active_id: 0, // 0-全部，1-我的收藏，2-TA的收藏
      omitAll: false,
    };
  },
  computed: {
    query() {
      const { query } = this.$route;
      return {
        item_id: query.item_id,
        page: Number(query.page) || 1,
        pageSize: this.pageSize,
        active_id: this.active_id,
        mid: query.mid,
      };
    },
    showPrivate() {
      const data = this.$store.getters["list/get"]({
        func: "fetchNftList",
        type: "jump",
        query: this.query,
      });
      const privateState = data?.extra?.private || false;
      return this.active_id === 1 ? false : privateState;
    },
  },
  async created() {
    const {
      active_id,
      item_id,
      f_source = "",
      from = "",
      omit_all = "",
    } = this.$route.query;
    const {
      data: { mid },
    } = await getUserInfo();
    // 判断主客态
    // 主态情况
    const master = [undefined, "", String(mid)];
    // query mid
    const linkMid = this.$route.query.mid;
    // true为主，false为客
    const isMaster = !!master.some((item) => item === linkMid);
    this.isMaster = isMaster;
    this.active_id = +active_id === 0 ? 0 : isMaster ? 1 : 2;
    // 过滤掉全部
    this.omitAll = omit_all === "1";
    if (this.omitAll) {
      this.active_id = isMaster ? 1 : 2;
    }

    reportEventJsb("sqzz.dressing.nft-list.0.show", ReportEventType.SHOW, {
      f_source,
      from,
      item_id,
      status: this.active_id,
    });
  },
  mounted() {
    initEnv();
  },
  watch: {
    active_id() {
      this.resetPage(1);
      const listData = this.$store.getters["list/get"]({
        func: "fetchNftList",
        type: "jump",
        query: this.query,
      });

      this.$nextTick(() => {
        if (listData?.fetched) this.$refs["loader"].refresh();
      });
    },
  },
};
</script>

<style lang="scss">
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
}

img,
span {
  vertical-align: middle;
}

img.jinkela {
  width: 100%;
}

body {
  width: 100%;
  min-height: 100%;
  background: #f6f7f8 url("./assets/bg.png");
  background-position: top center;
  background-size: contain;
  background-repeat: no-repeat;
  overflow-x: hidden;
}

.v-alert__title p {
  display: none;
}

div.v-navbar--shadow:after {
  background-image: none;
}

.panel {
  position: relative;
  min-height: 74px;
  padding: 25px 16px;
  margin: 1px 20px 20px;
  background-color: transparent;
  box-shadow: 0px 8px 20px rgba(174, 174, 174, 0.3);
  border-radius: 16px;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("./assets/panel_bg.png");
    background-size: cover;
    z-index: 0;
    border-radius: 16px;
  }

  .text {
    position: relative;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 10px;
      max-width: 240px;

      p {
        display: flex;
        font-size: 20px;
        color: #18191c;
        margin-right: 10px;
        span {
          display: inline-block;
          word-break: break-all;
        }

        img {
          margin-left: 3px;
          margin-top: 5px;
        }
      }

      div {
        font-size: 12px;
        color: #61666d;

        img {
          margin-right: 4px;
        }
      }
    }
  }
}

.nft-container {
  margin: 4px 0;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 44px;
  padding-bottom: calc(44px + constant(safe-area-inset-bottom));
  padding-bottom: calc(44px + env(safe-area-inset-bottom));

  > *:nth-child(odd) {
    padding-right: 7.5px;
  }

  > *:nth-of-type(even) {
    padding-left: 7.5px;
  }
}

.nft-pagination-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: white;
}
.list-error,
.list-nothing,
.list-loading,
.list-private {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 280px;
  }
  .list-tip {
    color: #9499a0;
    text-align: center;
    font-size: 16px;
    margin-top: 20px;
  }
}
.list-error {
  .list-error-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 44px;
    background: #ff6699;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    margin-top: 20px;
  }
}
</style>
